import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, CustomInput, CustomSelect, Modal, NoResult, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import SortBy from '../../SortBy';
import {
  FiltersContainer,
  FixedContainer,
  Legend,
  PaginationWrapper,
  ScormCard,
  Sorting,
} from './style';
import { DURATION_OPTIONS } from '../../../../utils/labels';
import {
  SCORM_CATEGORIES_GET,
  SCORM_LIST_GET,
} from '../../../../app/redux/actions/scorm';
import { convertDuration, timestampToDate } from '../../../../utils/common';
import { UPDATE_ACTIVITY } from '../../../../app/redux/actions/tutors';
import Pagination from '../../Pagination';

export const ModalSelectScormId = 'ModalSelectScorm';

const ModalSelectScorm = ({
  selectedScormIds,
  mediaIsPhone,
  isOpen,
  id,
  payload,
  list,
  pager,
  categories,
  getScormList,
  getCategories,
  modalClose,
  updateActivity,
}) => {
  const scrollableAreaRef = useRef(null);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [search, setSearch] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectedScorm, setSelectedScorm] = useState();
  const [showFilters, setShowFilters] = useState(true);

  useEffect(() => {
    if (id === ModalSelectScormId) {
      if (categories?.length <= 0) getCategories();
      if (isOpen) getScormList({ excluded_ids: selectedScormIds });
    }
    return () => {
      setSelectedFilters({});
      setSelectedScorm();
      setSearch('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    setShowFilters(!mediaIsPhone);
  }, [mediaIsPhone]);

  const onClickCard = (s) => {
    if (s?.id === selectedScorm?.id) setSelectedScorm();
    else setSelectedScorm(s);
  };

  const handlegetModules = (page) => {
    const formatFilters = {
      ...selectedFilters,
      excluded_ids: selectedScormIds,
      page,
    };
    if (formatFilters?.subject) {
      formatFilters.single_categories = formatFilters?.subject;
    } else if (formatFilters?.categories) {
      formatFilters.parent_categories = formatFilters?.categories;
    }
    delete formatFilters?.categories;
    delete formatFilters?.subject;
    getScormList(formatFilters);
  };

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) {
      handlegetModules();
    }
    if (selectedFilters.categories) {
      setSubjects(
        categories.find((c) => c?.id === selectedFilters?.categories)?.children
      );
    } else setSubjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handlegetModules(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <Modal
      title="Inserisci attività SCORM"
      modalId={ModalSelectScormId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <FixedContainer>
        <Text type="h2" mb={24}>
          Catalogo attività
        </Text>
        <FiltersContainer>
          <CustomInput
            size={mediaIsPhone ? 's' : 'm'}
            placeholder="Cosa vuoi cercare?..."
            isSearch
            icon="search-sm"
            isClearable
            onChange={(v) => setSearch(v)}
            onClickIcon={() =>
              setSelectedFilters({
                ...selectedFilters,
                search_text: search,
              })
            }
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                setSelectedFilters({
                  ...selectedFilters,
                  search_text: search,
                });
              }
            }}
            value={search}
          />
          {mediaIsPhone && (
            <CTA
              type="secondary"
              btnText={showFilters ? 'Nascondi' : 'Filtri'}
              onClick={() => setShowFilters(!showFilters)}
            />
          )}
          {showFilters && (
            <>
              <CustomSelect
                size={mediaIsPhone ? 'full' : 's'}
                placeholder="Area tematica"
                options={categories}
                onChange={(v) => {
                  setSelectedFilters({
                    ...selectedFilters,
                    subject: undefined,
                    categories: v?.id,
                  });
                }}
                isClearable
                key={`${isOpen}-category-select`}
              //^ trick to reset select when closing modal
              />
              <CustomSelect
                size={mediaIsPhone ? 'full' : 's'}
                placeholder="Materia"
                options={subjects}
                selected={
                  subjects?.find((s) => s?.id === selectedFilters?.subject) ||
                  null
                }
                isClearable
                onChange={(v) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    subject: v?.id,
                  })
                }
                key={`${isOpen}-subject-select`}
              //^ trick to reset select when closing modal
              />
              <CustomSelect
                size={mediaIsPhone ? 'full' : 's'}
                placeholder="Durata"
                options={DURATION_OPTIONS}
                isClearable
                onChange={(v) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    duration: v?.value,
                  })
                }
                key={`${isOpen}-duration-select`}
              //^ trick to reset select when closing modal
              />
              {mediaIsPhone && (
                <SortBy
                  onChange={(v) =>
                    setSelectedFilters({
                      ...selectedFilters,
                      sort_by: v?.value,
                    })
                  }
                />
              )}
            </>
          )}
        </FiltersContainer>
        {mediaIsPhone ? (
          <Text type="b3" mb={16}>
            {list?.length || 0} attività SCORM disponibili
          </Text>
        ) : (
          <Sorting className="d-flex g-24">
            <Text type="b3">
              {list?.length || 0} attività SCORM disponibili
            </Text>
            <SortBy
              onChange={(v) =>
                setSelectedFilters({
                  ...selectedFilters,
                  sort_by: v?.value,
                })
              }
            />
          </Sorting>
        )}
      </FixedContainer>
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{
          minWidth: 'min(1020px, 75vw)',
          minHeight: '30vh',
          maxWidth: 'var(--full-width)',
        }}
      >
        {!mediaIsPhone && (
          <Legend>
            <Text type="h3.5">Titolo</Text>
            <Text type="h3.5">Codice</Text>
            <Text type="h3.5">Data</Text>
            <Text type="h3.5">Durata</Text>
          </Legend>
        )}
        {list?.length > 0 ? (
          list.map((item) => {
            if (mediaIsPhone) {
              return (
                <ScormCard
                  key={`scorm-${item?.id}`}
                  className={item?.id === selectedScorm?.id ? 'active' : ''}
                  onClick={() => onClickCard(item)}
                >
                  <Text type="h3.5">Titolo</Text>
                  <Text type="h3">{item.title}</Text>
                  <Text type="h3.5">Codice</Text>
                  <div className="code">{item?.code}</div>
                  <Text type="h3.5">Data</Text>
                  <div className="date">{timestampToDate(item?.created)}</div>
                  <Text type="h3.5">Durata</Text>
                  <div className="duration">
                    {convertDuration(item?.duration)}
                  </div>
                  <div />
                  {item?.id === selectedScorm?.id ? (
                    <CTA type="tertiary" btnText="Annulla" bottomRight />
                  ) : (
                    <CTA type="tertiary" btnText="Seleziona" bottomRight />
                  )}
                </ScormCard>
              );
            }
            return (
              <ScormCard
                key={`scorm-${item?.id}`}
                className={item?.id === selectedScorm?.id ? 'active' : ''}
                onClick={() => onClickCard(item)}
              >
                <Text type="h3">{item.title}</Text>
                <div className="code">{item?.code}</div>
                <div className="date">{timestampToDate(item?.created)}</div>
                <div className="duration">
                  {convertDuration(item?.duration)}
                </div>
                {item?.id === selectedScorm?.id ? (
                  <CTA type="tertiary" btnText="Annulla" />
                ) : (
                  <CTA type="tertiary" btnText="Seleziona" />
                )}
              </ScormCard>
            );
          })
        ) : (
          <NoResult />
        )}
        <PaginationWrapper>
          <Pagination
            pager={pager}
            callBack={loadMore}
            setItemsPerPage={setItemsPerPage}
          />
        </PaginationWrapper>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="Inserisci"
          fullsize={mediaIsPhone}
          disabled={!selectedScorm}
          onClick={() => {
            updateActivity(
              payload?.sectionKey,
              payload?.activityKey,
              'data',
              selectedScorm
            );
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalSelectScorm.propTypes = {
  selectedScormIds: PropTypes.array,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  isOpen: PropTypes.bool,
  id: PropTypes.string,
  payload: PropTypes.object,
  list: PropTypes.array,
  categories: PropTypes.array,
  pager: PropTypes.object,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getScormList: PropTypes.func,
  getCategories: PropTypes.func,
  updateActivity: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { isOpen, id, payload } = state.app.modal;
      const { list, pager, categories } = state.scorm;
      return { isOpen, id, payload, list, categories, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getCategories: () => dispatch({ type: SCORM_CATEGORIES_GET._REQUEST }),
      getScormList: (filters) =>
        dispatch({ type: SCORM_LIST_GET._REQUEST, filters }),
      updateActivity: (secId, actId, field, value) =>
        dispatch({ type: UPDATE_ACTIVITY, secId, actId, field, value }),
    })
  ),
  withMediaQueries
)(ModalSelectScorm);
